import React, { useMemo, FC } from "react";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import useTitle24Selector from "./useTitle24Selector";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  "&.MuiTableCell-body": {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const StyledTable = styled(Table)({
  width: 200,
  border: "1px solid black",
});

const Row = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledTypography = styled(Typography)({
  color: "red",
});

const Title24: FC = () => {
  const {
    text,
    ufactor,
    shgc,
    customGlass,
    intUfactor,
    intShgc,
    isAluminum
  } = useTitle24Selector();

  const table = useMemo(() => {
    return (
      <Row>
        {ufactor && shgc ? (
          <TableContainer style={{ maxWidth: 200 }}>
            <StyledTable size="small" aria-label="customized table">
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    U-Factor
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {ufactor === "0.53" ? (
                      <span style={{ color: "red" }}>{ufactor} *</span>
                    ) : (
                      ufactor
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    SHGC
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {shgc === "0.53" ? (
                      <span style={{ color: "red" }}>{shgc} *</span>
                    ) : (
                      shgc
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </StyledTable>
          </TableContainer>
        ) : (
          <Typography variant="body1">{text}</Typography>
        )}
        <div style={{ maxWidth: 300, marginLeft: 40 }}>
          <Typography variant="body2">
            Title 24 is now Climate Zone specific, please verify with your
            local requirements.
          </Typography>
        </div>
        {/* {title24Compliant && ufactor && shgc && (
          <div style={{ marginLeft: 20 }}>
            <Grow in={true}>
              <div>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId="title24"
                >
                  <Transformation width="100" height="100" crop="scale" />
                </Image>
              </div>
            </Grow>
          </div>
        )} */}
      </Row>
    );
  }, [intUfactor, intShgc]);

  if (customGlass) {
    return (
      <>
        {table}
        <StyledTypography variant="subtitle1">
          * NOTE: This unit has custom glass
        </StyledTypography>
      </>
    );
  }

  //Alumonum bifold doors and windows have test results
  // if (isAluminum) {
  //   return (
  //     <>
  //       {table}
  //       <StyledTypography variant="subtitle1">
  //         * NOTE: Pending Test Results
  //       </StyledTypography>
  //     </>
  //   );
  // }

  return (
    <>
      {table}
      {(intUfactor === 0.53 || intShgc === 0.53) && (
        <StyledTypography variant="subtitle1">
          * NOTE: Does not meet title 24
        </StyledTypography>
      )}
    </>
  );
};

export default Title24;
